import axios from 'axios';
import * as constants from '../utils/constants';

import AuthService from '../utils/authService';

const baseurl = constants.default.baseUrl;
const client = AuthService.getClient();

const AdminAPI = {

    getMenu: () => {

        return axios.get(baseurl + '/api/menu', { headers: { Authorization: `Bearer ${AuthService.getToken()}` }});
    },

/*     getUsers: (companyId, userId) => {

        return axios.get(baseurl + '/api/user?companyid=' + companyId + '&userId=' + userId, { headers: { Authorization: `Bearer ${AuthService.getToken()}` }});

    }, */

    getRoles: () => {

        return axios.get(baseurl + '/api/user/getRoles', { headers: { Authorization: `Bearer ${AuthService.getToken()}` }});

    },

/*     getProjects: (companyId, projectId) => {

        return axios.get(baseurl + '/api/project?companyid=' + companyId + '&projectId=' + projectId, { headers: { Authorization: `Bearer ${AuthService.getToken()}` }});

    }, */

    
  /*   getCompanies: (i, j, k, l) => {

        return axios.get(baseurl + '/api/company', { params: { pageSize: i, page: j, sorted: k, filtered: l }, 
        headers: { Authorization: `Bearer ${AuthService.getToken()}` }});

    }, */

    getHomeStats: (week) => {

        return axios.get(baseurl + '/api/home?week=' + week, { headers: { Authorization: `Bearer ${AuthService.getToken()}` }});
    },

    getJobType: () => {

        return axios.get(baseurl + '/api/jobType', { headers: { Authorization: `Bearer ${AuthService.getToken()}` }});

    },

    getAccidentType: () => {

        return axios.get(baseurl + '/api/accidentType', { headers: { Authorization: `Bearer ${AuthService.getToken()}` }});
    },

    
  
    
    getUser: (id) => {

        return axios.get(baseurl + '/api/user?companyId=&userId=' + id, { headers: { Authorization: `Bearer ${AuthService.getToken()}` }});

    },

    getFatigueDefault: (id) => {

        return axios.get(baseurl + '/api/fatigueDefaults/GetFatigueDefaultById?id=' + id, { headers: { Authorization: `Bearer ${AuthService.getToken()}` }});

    },

    getTravelTimeById: (id) => {

        return axios.get(baseurl + '/api/travelTime/GetTravelTimeById?id=' + id, { headers: { Authorization: `Bearer ${AuthService.getToken()}` }});

    },

    getTravelTime: (str) => {

        return axios.get(baseurl + '/api/travelTime?' + str, { headers: { Authorization: `Bearer ${AuthService.getToken()}` }});

    },

    getProject: (id) => {

        return axios.get(baseurl + '/api/project?companyId=0&projectId=' + id, { headers: { Authorization: `Bearer ${AuthService.getToken()}` }});

    },

    getCompany: (id) => {

        return axios.get(baseurl + '/api/company?id=' + id, { headers: { Authorization: `Bearer ${AuthService.getToken()}` }});

    },

    getCollars: () => {

        return axios.get(baseurl + '/api/collar?id=0', { headers: { Authorization: `Bearer ${AuthService.getToken()}` }});

    },

    getCollar: (id) => {

        return axios.get(baseurl + '/api/collar?id=' + id, { headers: { Authorization: `Bearer ${AuthService.getToken()}` }});

    },

    getPermissionTypes: () => {
        return axios.get(baseurl + '/api/user/GetPermissionTypes', { headers: { Authorization: `Bearer ${AuthService.getToken()}` }});
    },

    getUserLocation: () => {
        return axios.get(baseurl + '/api/userLocation', { headers: { Authorization: `Bearer ${AuthService.getToken()}` }});
    },

    getFatigueDefaults: (str) => {
  
        return axios.get(baseurl + '/api/fatigueDefaults?' + str, 
        { 
        headers: { Authorization: `Bearer ${AuthService.getToken()}` }});
    },

    getFatigueDefaultById: (id) => {
        return axios.get(baseurl + '/api/fatigueDefaults/GetFatigueDefaultById?id=' + id, 
        { 
        headers: { Authorization: `Bearer ${AuthService.getToken()}` }});
    },
    
    reCalculateTravelTime: () => {
        return axios.get(baseurl + '/api/travelTime/recalculateTravelTimes', 
        { 
        headers: { Authorization: `Bearer ${AuthService.getToken()}` }});
    },

    deleteFatigueDefaults: (id) => {
        return axios.delete(baseurl + '/api/fatigueDefaults', 
        { params: { id: id }, 
          headers: { Authorization: `Bearer ${AuthService.getToken()}` }});
    },

    
    delete: (path, id) => {

        return axios.delete(baseurl + path, 
        { params: { id: id }, 
          headers: { Authorization: `Bearer ${AuthService.getToken()}` }});

    },

    deleteUserLocation: (id) => {
        return axios.delete(baseurl + '/api/userLocation', 
        { params: { userId: id }, 
          headers: { Authorization: `Bearer ${AuthService.getToken()}` }});
    },

    get: (path, params) => {

        return axios.get(baseurl + path, 
        { params: { ...params }, 
          headers: { Authorization: `Bearer ${AuthService.getToken()}` }});

    },

    saveFatigueDefaults: (obj) => {
        return axios({
            method: 'post',
            url: baseurl + '/api/fatigueDefaults',
            data: obj,
            headers: { Authorization: `Bearer ${AuthService.getToken()}` } 
        })

    },

    saveJobType: (obj) => {
        return axios({
            method: 'post',
            url: baseurl + '/api/jobType',
            data: obj,
            headers: { Authorization: `Bearer ${AuthService.getToken()}` } 
        })

    },

    saveUser: (obj) => {
  
        return axios({
            method: 'post',
            url: baseurl + '/api/user',
            data: {user: obj, client: client},
            headers: { Authorization: `Bearer ${AuthService.getToken()}` } 
        })

    },

    saveTravelTime: (obj) => {
        return axios({
            method: 'post',
            url: baseurl + '/api/travelTime',
            data: obj,
            headers: { Authorization: `Bearer ${AuthService.getToken()}` } 
        })
    },

    
    saveCollar: (obj) => {
        return axios({
            method: 'post',
            url: baseurl + '/api/collar',
            data: obj,
            headers: { Authorization: `Bearer ${AuthService.getToken()}` } 
        })
    },

 
    saveJobType: (obj) => {
        return axios({
            method: 'post',
            url: baseurl + '/api/jobType',
            data: obj,
            headers: { Authorization: `Bearer ${AuthService.getToken()}` } 
        })
    },

    saveUserLocation: (obj) => {
        return axios({
            method: 'post',
            url: baseurl + '/api/userLocation',
            data: obj,
            headers: { Authorization: `Bearer ${AuthService.getToken()}` } 
        })
    },

    resetPassword: (obj) => {
        return axios({
            method: 'post',
            url: baseurl + '/api/user/resetPassword',
            data: obj,
            headers: { Authorization: `Bearer ${AuthService.getToken()}` }
        })

    },

    // CHECKPOINT-75: admin password management + forced self-change.
    getPasswordPolicy: () => {
        return axios.get(baseurl + '/api/passwordPolicy',
            { headers: { Authorization: `Bearer ${AuthService.getToken()}` } });
    },

    getPasswordRules: () => {
        return axios.get(baseurl + '/api/passwordPolicy/rules',
            { headers: { Authorization: `Bearer ${AuthService.getToken()}` } });
    },

    updatePasswordPolicy: (obj) => {
        return axios({
            method: 'put',
            url: baseurl + '/api/passwordPolicy',
            data: obj,
            headers: { Authorization: `Bearer ${AuthService.getToken()}` }
        });
    },

    adminResetPassword: (obj) => {
        // Route is /AdminPasswordReset (not /AdminResetPassword): the server's
        // tenant resolver hijacks any URL containing "ResetPassword".
        return axios({
            method: 'post',
            url: baseurl + '/api/user/AdminPasswordReset',
            data: obj,
            headers: { Authorization: `Bearer ${AuthService.getToken()}` }
        });
    },

    adminSetPassword: (obj) => {
        return axios({
            method: 'post',
            url: baseurl + '/api/user/AdminSetPassword',
            data: obj,
            headers: { Authorization: `Bearer ${AuthService.getToken()}` }
        });
    },

    changeOwnPassword: (obj) => {
        return axios({
            method: 'post',
            url: baseurl + '/api/user/ChangeOwnPassword',
            data: obj,
            headers: { Authorization: `Bearer ${AuthService.getToken()}` }
        });
    },

    saveCompany: (obj) => {
        
        return axios({
            method: 'post',
            url: baseurl + '/api/company',
            data: obj,
            headers: { Authorization: `Bearer ${AuthService.getToken()}` } 
        })

    },

    saveProject: (obj) => {
        
        return axios({
            method: 'post',
            url: baseurl + '/api/project',
            data: obj,
            headers: { Authorization: `Bearer ${AuthService.getToken()}` } 
        })

    }
}

export default AdminAPI;
